import type { Study, ConcentrationTimePoint } from '@bioavail/shared-types';
import { createArm, createStudy } from './factory';
import {
  RouteOfAdministration as ROA,
  ArmRole as AR,
  DoseUnit as DU,
  ConcentrationUnit as CU,
  TimeUnit as TU,
  CalculationMode as CM,
  AucInterval as AI,
} from '@bioavail/shared-types';

/**
 * Worked example: Absolute F — IV reference (100 mg) vs oral test (200 mg).
 * Known-good F ≈ 0.44 (moderate bioavailability).
 */
export function absoluteFExample(): Study {
  const ivPoints: ConcentrationTimePoint[] = [
    { time: 0.25, concentration: 1850, isBlq: false },
    { time: 0.5, concentration: 1450, isBlq: false },
    { time: 1, concentration: 980, isBlq: false },
    { time: 2, concentration: 540, isBlq: false },
    { time: 4, concentration: 180, isBlq: false },
    { time: 6, concentration: 62, isBlq: false },
    { time: 8, concentration: 21, isBlq: false },
    { time: 12, concentration: 2.4, isBlq: false },
    { time: 16, concentration: 0.3, isBlq: false },
  ];

  const oralPoints: ConcentrationTimePoint[] = [
    { time: 0.25, concentration: 0, isBlq: true },
    { time: 0.5, concentration: 48, isBlq: false },
    { time: 1, concentration: 312, isBlq: false },
    { time: 2, concentration: 540, isBlq: false },
    { time: 4, concentration: 380, isBlq: false },
    { time: 6, concentration: 210, isBlq: false },
    { time: 8, concentration: 115, isBlq: false },
    { time: 12, concentration: 33, isBlq: false },
    { time: 16, concentration: 9.5, isBlq: false },
    { time: 24, concentration: 0.8, isBlq: false },
  ];

  return createStudy({
    name: 'Example — Absolute F (IV 100mg vs Oral 200mg)',
    mode: CM.Absolute,
    aucInterval: AI.ZeroToInf,
    arms: [
      createArm({
        id: 'arm-test',
        label: 'Oral 200 mg tablet',
        route: ROA.Oral,
        role: AR.Test,
        dose: 200,
        doseUnit: DU.Mg,
        concentrationUnit: CU.NgPerMl,
        timeUnit: TU.Hour,
        dataPoints: oralPoints,
      }),
      createArm({
        id: 'arm-ref',
        label: 'IV 100 mg infusion',
        route: ROA.IV,
        role: AR.Reference,
        dose: 100,
        doseUnit: DU.Mg,
        concentrationUnit: CU.NgPerMl,
        timeUnit: TU.Hour,
        dataPoints: ivPoints,
      }),
    ],
  });
}
